import { blockedwordConstants } from '../constants';
import { blockedwordService } from '../services';
import { showToast } from '../services/toast';

export const blockedwordActions = {
    fetchBlockedWords
};

function fetchBlockedWords() {
    return dispatch => {
        dispatch(request());

        blockedwordService.fetchBlockedWords()
            .then(
                response => {
                    dispatch(success(response.data));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    showToast(error.toString(), 'error');
                }
            );
    };

    function request() { return { type: blockedwordConstants.FETCH_BLOCKEDWORDS_REQUEST } }
    function success(blockedwords) { return { type: blockedwordConstants.FETCH_BLOCKEDWORDS_SUCCESS, blockedwords } }
    function failure(error) { return { type: blockedwordConstants.FETCH_BLOCKEDWORDS_FAILURE, error } }
}